import posthog from "posthog-js";

const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ||
  import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ||
  "phc_sPoRZcFMDWpQfqND2ZMJiqV8sAdpMsJt8eu8FpFR89EG";

const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com";

let initialized = false;

export function initPostHog(): typeof posthog | null {
  if (typeof window === "undefined") return null;
  if (initialized) return posthog;

  if (!POSTHOG_KEY) {
    return null;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: "history_change",
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
    },
    mask_all_element_attributes: true,
    mask_all_text: true,
  });

  initialized = true;
  return posthog;
}

export function identifyUser(
  userId: string,
  traits?: {
    email?: string;
    name?: string | null;
    tenantId?: string;
    authMode?: string;
  },
) {
  if (!initialized) initPostHog();
  if (!initialized) return;

  posthog.identify(userId, {
    ...(traits?.email ? { email: traits.email } : {}),
    ...(traits?.name ? { name: traits.name } : {}),
    ...(traits?.tenantId ? { tenant_id: traits.tenantId } : {}),
    ...(traits?.authMode ? { auth_mode: traits.authMode } : {}),
  });

  if (traits?.tenantId) {
    posthog.group("tenant", traits.tenantId);
  }
}

export function resetUser() {
  if (!initialized) return;
  posthog.reset();
}

export { posthog };
